<template>
  <AppConditionalWrapper :name="block.data.useContainer ? 'AppContainer' : null">
    <Component :is="resolvedComponent" :uid="block.id" class="app-content-block" :data="normalizedBlockData" />
  </AppConditionalWrapper>
</template>

<script>
import { snakeToPascal } from '@/helpers/str';
import AppConditionalWrapper from '@/components/AppConditionalWrapper.vue';

export default {
  components: { AppConditionalWrapper },
  props: {
    block: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      resolvedComponent: this.resolve(this.block.type),
    };
  },

  computed: {
    normalizedBlockData() {
      if (this.block.type === 'accordion') {
        const { accordionItems, ...rest } = this.block.data;

        return accordionItems ? { ...rest, items: accordionItems } : rest;
      }

      if (this.block.type === 'review_carousel') {
        const { reviews, ...rest } = this.block.data;

        return reviews ? { ...rest, items: reviews } : rest;
      }

      return this.block.data;
    },
  },

  watch: {
    'block.type'(type) {
      this.resolvedComponent = this.resolve(type);
    },
  },

  methods: {
    resolve(type) {
      const componentName = `AppContentBlock${snakeToPascal(type)}`;

      if (!componentName) {
        return 'div';
      }

      try {
        return require(`./content-blocks/${componentName}.vue`).default;
      } catch {
        return 'div';
      }
    },
  },
};
</script>
